import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTrainFrontView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrainFrontView"><Path d="M6.5 2.5H17.5L20.5 5.08621V17.5H3.5V5.08621L6.5 2.5Z" stroke="currentColor"/><Path d="M3.5 11.5H20.5" stroke="currentColor"/><Circle cx="8" cy="14.25" r="1" fill="currentColor"/><Circle cx="16" cy="14.25" r="1" fill="currentColor"/><Path d="M6.94141 18L4.94141 22H6.05944L8.05944 18H6.94141Z" fill="currentColor"/><Path d="M15.9414 18L17.9414 22H19.0594L17.0594 18H15.9414Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrainFrontView;
